import { useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";
import { Ref } from "vue";

import { useServices } from "@/configuration/plugins/app/app-provider.configuration";
import { SiteSectionQueryKeys } from "@/data/api/v4b/site-section/site-section-query-keys";
import { SiteSectionId, V4HSiteId } from "@/data/common/ids";

export function useSiteSectionAppliancesV2Query(siteId: Ref<V4HSiteId>, sectionId: Ref<SiteSectionId>) {
  const v4b = useServices().v4b.clientSdk;

  return useQuery({
    queryKey: SiteSectionQueryKeys.findAppliancesV2(siteId, sectionId),
    queryFn: () => v4b.siteSection.findAppliances(toValue(sectionId)),
  });
}
